import React, { useState } from "react";
import PropTypes from "prop-types";
import Input from "../common/Input";
import { STATUS } from "../common/Const";

function SsoProfileCompletion({
  email, firstName, lastName, onSubmit,
}) {
  const [formData, setFormData] = useState({
    firstName,
    lastName,
    mobile: "",
  });
  const [status, setStatus] = useState(STATUS.IDLE);
  const [error, setError] = useState("");

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const missingField = [
      { name: "firstName", message: "Imię jest wymagane." },
      { name: "lastName", message: "Nazwisko jest wymagane." },
      { name: "mobile", message: "Telefon jest wymagany." },
    ].find(field => !formData[field.name].trim());

    if (missingField) {
      setError(missingField.message);
      setStatus(STATUS.SUBMITTED);
      return;
    }

    setStatus(STATUS.SUBMITTING);
    onSubmit({
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim(),
      mobile: formData.mobile.trim(),
    })
      .catch((submitError) => {
        setError(submitError.message);
        setStatus(STATUS.SUBMITTED);
      });
  };

  return (
    <div className="quiz-text">
      <h2><strong>Uzupełnij dane</strong></h2>
      <p>{email}</p>
      {error && status === STATUS.SUBMITTED && <div role="alert" className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label="Imię"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              error={error && !formData.firstName.trim() ? error : undefined}
              placeholder="Imię"
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label="Nazwisko"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              error={error && !formData.lastName.trim() ? error : undefined}
              placeholder="Nazwisko"
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label="Telefon"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              error={error && !formData.mobile.trim() ? error : undefined}
              placeholder="Telefon"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-2">
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={status === STATUS.SUBMITTING}>
              Kontynuuj
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

SsoProfileCompletion.propTypes = {
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

SsoProfileCompletion.defaultProps = {
  email: "",
  firstName: "",
  lastName: "",
};

export default SsoProfileCompletion;
